import {BASE_URL_WEB} from './constants';

export const INVOICE_ACCOUNT_CREATION_MESSAGE =
  'To pay the invoice, you must first create a CoachFirst account.';

export const invoiceSignupContextFromReturnUrl = returnUrl => {
  if (typeof returnUrl !== 'string' || !returnUrl.startsWith('/invoices/')) {
    return null;
  }

  const [pathAndQuery] = returnUrl.split('#');
  const [pathname, queryString = ''] = pathAndQuery.split('?');
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length !== 2 || parts[0] !== 'invoices') {
    return null;
  }

  let invoiceId = '';
  try {
    invoiceId = decodeURIComponent(parts[1]);
  } catch (error) {
    return null;
  }

  const companyId = new URLSearchParams(queryString).get('companyId') || '';
  if (!invoiceId || !companyId) {
    return null;
  }

  return {invoiceId, companyId};
};

export const invoiceSignupPrefillUrlFromReturnUrl = returnUrl => {
  const context = invoiceSignupContextFromReturnUrl(returnUrl);
  if (!context) {
    return '';
  }

  const params = new URLSearchParams({companyId: context.companyId});
  return `${BASE_URL_WEB}public/invoices/${encodeURIComponent(
    context.invoiceId
  )}/signup-prefill?${params.toString()}`;
};
